import {
  FlexProps,
  Flex,
  Heading,
  Box,
  SimpleGrid,
  HStack,
  Text,
} from '@chakra-ui/react';
import { IBookingCancellationHistoryBase } from '../../../../../../../../../models/bookings';
import { IUserBase } from '../../../../../../../../../models/users';
import { maskDateTime } from '../../../../../../../../../utils/formatters/handleMask';

interface IDetailedCancellationHistory extends IBookingCancellationHistoryBase {
  user: IUserBase;
}

interface IBookingCancellationInfoProps extends FlexProps {
  cancellationHistory: IDetailedCancellationHistory;
}

const BookingCancellationInfo = ({
  cancellationHistory,
  ...rest
}: IBookingCancellationInfoProps): JSX.Element => (
  <Flex direction="column" px="8" {...rest}>
    <Heading size="md" fontWeight="normal">
      Cancelamento
    </Heading>

    <Box mt="4" px="4">
      <SimpleGrid columns={[1, 1, 1, 1, 4]} spacing="4" w="100%" fontSize="sm">
        <HStack>
          <Text>Cancelado por:</Text>
          <Text fontSize="lg" fontWeight="bold">
            {cancellationHistory.user.name}
          </Text>
        </HStack>

        <HStack>
          <Text>Minutos antes do início do evento:</Text>
          <Text color="gray.500">
            {cancellationHistory.minutesBeforeScheduleStart}
          </Text>
        </HStack>

        <HStack>
          <Text>Motivo:</Text>
          <Text color="gray.500">{cancellationHistory.reason ?? '-'}</Text>
        </HStack>

        <HStack>
          <Text>Cancelado em:</Text>
          <Text color="gray.500">
            {maskDateTime(cancellationHistory.createdAt)}
          </Text>
        </HStack>
      </SimpleGrid>
    </Box>
  </Flex>
);

export default BookingCancellationInfo;
